import React from "react";
import { Col, Row, Divider } from "antd";

import { PlusCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

import "../../../styles/modules/patient.less";
import IntlMessages from "../../../util/IntlMessages";
import { APP_ROUTES } from "../../../constants/Routes";
import ButtonComponent from "../../../components/Button/ButtonComponent";

const DoctorListHeader = () => {
  return (
    <div>
      <Row className="p-10 Add-button">
        <Col>
          <p className="header-tag">{<IntlMessages id={"Addnew.doctor"} />}</p>
        </Col>
        <Col>
          <Link to={APP_ROUTES.DOCTORADDNEW}>
            <ButtonComponent
              type="primary"
              label={<IntlMessages id={"Addnew.patient.addnew"} />}
              icon={<PlusCircleOutlined />}
            />
          </Link>
        </Col>
      </Row>

      <Divider />
    </div>
  );
};

export default DoctorListHeader;
